import { useCallback, useEffect, useRef } from "react";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { refreshUnreadCountAsync } from "../notificationsSlice";

export const useUnreadCountRefresh = (userId: number): (() => void) => {
  const dispatch = useAppDispatch();
  const refreshRef = useRef<() => void>(() => undefined);

  useEffect(() => {
    if (!userId) return undefined;
    let pending = false;
    let dirty = false;
    let disposed = false;
    const refresh = async () => {
      dirty = true;
      if (pending) return;
      pending = true;
      try {
        while (dirty && !disposed) {
          dirty = false;
          // Serialize refreshes so arrivals during a request get one follow-up.
          // eslint-disable-next-line no-await-in-loop
          await dispatch(refreshUnreadCountAsync({ userId }));
        }
      } finally {
        pending = false;
      }
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    refreshRef.current = refresh;
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      disposed = true;
      refreshRef.current = () => undefined;
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [dispatch, userId]);

  return useCallback(() => {
    refreshRef.current();
  }, []);
};
